import { useState } from 'react';
import { Avatar, getCat, fmt } from '../lib/helpers';
import { ExpenseDetailModal } from '../components/ExpenseDetailModal';

export function GroupView({ group, people, expenses, balances, meId, onDeleteExpense, onSettle }) {
  const [tab, setTab] = useState('expenses');
  const [selected, setSelected] = useState(null);

  const personById = (id) => people.find(p => p.id === id);
  const members = people.filter(p => group.members.includes(p.id));
  const groupExpenses = expenses.filter(e => e.group_id === group.id)
    .sort((a, b) => new Date(b.date) - new Date(a.date));
  const total = groupExpenses.reduce((s, e) => s + e.amount, 0);

  const groupTxns = (balances.transactions || []).filter(t =>
    group.members.includes(t.from) && group.members.includes(t.to)
  );

  return (
    <>
      <div className="tab-bar">
        {['expenses', 'balances'].map(t => (
          <button key={t} className={`tab${tab === t ? ' active' : ''}`} onClick={() => setTab(t)}>
            {t.charAt(0).toUpperCase() + t.slice(1)}
          </button>
        ))}
      </div>

      <div className="content">
        {tab === 'expenses' ? (
          <div className="expense-list">
            {groupExpenses.length === 0 && <div className="empty">No expenses yet. Add one!</div>}
            {groupExpenses.map(exp => {
              const cat = getCat(exp.category);
              const payer = personById(exp.paid_by);
              const mySplit = exp.split.find(s => s.person_id === meId);
              const iAmPayer = exp.paid_by === meId;
              const iAmSplit = !!mySplit;
              let shareLabel = '', shareClass = 'text-muted';
              if (iAmPayer && iAmSplit) {
                const lent = exp.amount - mySplit.share;
                if (lent > 0.01) { shareLabel = `you lent ${fmt(lent)}`; shareClass = 'text-green'; }
                else shareLabel = 'paid by you';
              } else if (iAmPayer) {
                shareLabel = `you lent ${fmt(exp.amount)}`; shareClass = 'text-green';
              } else if (iAmSplit) {
                shareLabel = `you owe ${fmt(mySplit.share)}`; shareClass = 'text-red';
              } else {
                shareLabel = 'not involved';
              }
              return (
                <div className="expense-row" key={exp.id} onClick={() => setSelected(exp)}>
                  <div className="exp-icon" style={{ background: group.color + '22', color: group.color }}>
                    {cat.icon}
                  </div>
                  <div className="exp-info">
                    <div className="exp-name">{exp.name}</div>
                    <div className="exp-meta">{payer?.name} paid · {exp.date}</div>
                  </div>
                  <div className="exp-right">
                    <div className="exp-total">{fmt(exp.amount)}</div>
                    <div className={`exp-share ${shareClass}`}>{shareLabel}</div>
                  </div>
                </div>
              );
            })}
          </div>
        ) : (
          <>
            <div className="balance-grid" style={{ gridTemplateColumns: 'repeat(3,1fr)', marginBottom: '1.25rem' }}>
              <div className="bal-card"><div className="bal-label">Total spent</div><div className="bal-amount">{fmt(total)}</div></div>
              <div className="bal-card"><div className="bal-label">Members</div><div className="bal-amount">{members.length}</div></div>
              <div className="bal-card"><div className="bal-label">Expenses</div><div className="bal-amount">{groupExpenses.length}</div></div>
            </div>

            <div className="section-label" style={{ marginBottom: '0.6rem' }}>Balances</div>
            <div className="settle-list">
              {members.map(p => {
                const net = -(balances.netTotals?.[p.id] || 0);
                return (
                  <div className="settle-row" key={p.id}>
                    <Avatar person={p} />
                    <span className="settle-name">{p.name}</span>
                    <span className={`settle-amount ${net > 0.01 ? 'text-green' : net < -0.01 ? 'text-red' : 'text-muted'}`}>
                      {net > 0.01 ? `gets back ${fmt(net)}` : net < -0.01 ? `owes ${fmt(net)}` : 'settled up'}
                    </span>
                  </div>
                );
              })}
            </div>

            {groupTxns.length > 0 && (
              <>
                <div className="section-label" style={{ marginTop: '1rem', marginBottom: '0.6rem' }}>Settle up</div>
                <div className="settle-list">
                  {groupTxns.map((t, i) => {
                    const from = personById(t.from);
                    const to = personById(t.to);
                    if (!from || !to) return null;
                    return (
                      <div className="settle-row" key={i}>
                        <Avatar person={from} />
                        <span className="settle-name">{from.name}</span>
                        <span className="settle-arrow">→</span>
                        <Avatar person={to} />
                        <span className="settle-name">{to.name}</span>
                        <span className="settle-amount text-red">{fmt(t.amount)}</span>
                        {(t.from === meId || t.to === meId) && (
                          <button className="btn" style={{ padding: '4px 10px', fontSize: 12 }}
                            onClick={() => onSettle({ from_person: t.from, to_person: t.to, amount: t.amount })}>
                            Settle
                          </button>
                        )}
                      </div>
                    );
                  })}
                </div>
              </>
            )}
          </>
        )}
      </div>

      {selected && (
        <ExpenseDetailModal
          expense={selected} people={people} groups={[group]}
          onDelete={onDeleteExpense} onClose={() => setSelected(null)}
        />
      )}
    </>
  );
}
